import { atomWithPolling } from '@exodus/headless-ui';
import configAtom from './config.js';
import fromAssetAtom from './from-asset.js';
import toAssetAtom from './to-asset.js';
import { computePollInterval } from '../helpers/poll-interval.js';
const buildLimitsKey = (fromTicker, toTicker) => `${fromTicker}_${toTicker}`;
const limitsAtom = atomWithPolling(async (get, { exodus }) => {
    const fromAsset = get(fromAssetAtom);
    const toAsset = get(toAssetAtom);
    const config = get(configAtom);
    const value = await exodus.exchange
        .getLimits({
        pairId: buildLimitsKey(fromAsset.ticker, toAsset.ticker),
        expiryMarginMs: config.expiryMarginMs,
    })
        .catch(() => null);
    const interval = computePollInterval({
        expiry: value?.expiry,
        expiryMarginMs: config.expiryMarginMs,
        defaultPollIntervalMs: config.defaultPollIntervalMs,
        stalePollIntervalMs: config.stalePollIntervalMs,
    });
    return { value, interval };
});
limitsAtom.cacheKey = (get) => buildLimitsKey(get(fromAssetAtom).ticker, get(toAssetAtom).ticker);
export default limitsAtom;
